<template>
  <div class="card">
    <CardIcon :class="{ inactive: !active }" />
  </div>
</template>

<script>
import CardIcon from '~/assets/svg/card.svg?component'

export default {
  components: {
    CardIcon,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="sass" scoped>
  .card
    :deep(svg)
      &.inactive
        path:nth-child(1)
          fill: #D1D1D1
        path:nth-child(2)
          fill: #686868
        path:nth-child(3)
          fill: #C4C4C4
        path:nth-child(4)
          fill: #C4C4C4
</style>
